/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class CustomerApplicationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增客户申请
     * @param customerApplicationInsertDTO customerApplicationInsertDTO
     * @return OK
     */
    insert(customerApplicationInsertDTO: CustomerApplicationInsertDTO): Promise<CustomerApplicationVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-application/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerApplicationInsertDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<CustomerApplicationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CustomerApplicationVO.fromJS(resultData200) : new CustomerApplicationVO();
            return result200;
        }
        return Promise.resolve<CustomerApplicationVO>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param customerApplicationSelectDTO customerApplicationSelectDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, customerApplicationSelectDTO: CustomerApplicationSelectDTO, size: number | null | undefined): Promise<IPageOfCustomerApplicationVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-application/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerApplicationSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfCustomerApplicationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerApplicationVO.fromJS(resultData200) : new IPageOfCustomerApplicationVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerApplicationVO>(<any>null);
    }

    /**
     * 处理客户申请
     * @param customerApplicationProcessDTO customerApplicationProcessDTO
     * @return OK
     */
    process(customerApplicationProcessDTO: CustomerApplicationProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-application/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerApplicationProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class CustomerHistoryAddressServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<ROfCustomerHistoryAddressVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-history-address/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfCustomerHistoryAddressVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfCustomerHistoryAddressVO.fromJS(resultData200) : new ROfCustomerHistoryAddressVO();
            return result200;
        }
        return Promise.resolve<ROfCustomerHistoryAddressVO>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param customerHistoryAddressSelectDTO customerHistoryAddressSelectDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, customerHistoryAddressSelectDTO: CustomerHistoryAddressSelectDTO, size: number | null | undefined): Promise<ROfIPageOfCustomerHistoryAddressVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-history-address/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerHistoryAddressSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfCustomerHistoryAddressVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfCustomerHistoryAddressVO.fromJS(resultData200) : new ROfIPageOfCustomerHistoryAddressVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfCustomerHistoryAddressVO>(<any>null);
    }

    /**
     * 删除历史地址
     * @param ids ids
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-history-address/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或更改历史地址
     * @param customerHistoryAddressSubmitDTO customerHistoryAddressSubmitDTO
     * @return OK
     */
    submit(customerHistoryAddressSubmitDTO: CustomerHistoryAddressSubmitDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-history-address/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerHistoryAddressSubmitDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class CustomerMenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 权限分配树形结构
     * @return OK
     */
    grantTree(): Promise<CustomerMenuVO[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-menu/grant-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrantTree(_response);
        });
    }

    protected processGrantTree(response: AxiosResponse): Promise<CustomerMenuVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerMenuVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CustomerMenuVO[]>(<any>null);
    }

    /**
     * 角色授权的菜单codes
     * @param customerId 客户ID
     * @return OK
     */
    getRoleGrantCodes(customerId: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-menu/role-grant-codes?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRoleGrantCodes(_response);
        });
    }

    protected processGetRoleGrantCodes(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 角色授权的菜单ids
     * @param customerId 客户ID
     * @return OK
     */
    getRoleGrantIds(customerId: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-menu/role-grant-ids?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRoleGrantIds(_response);
        });
    }

    protected processGetRoleGrantIds(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class CustomerOauthServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 扫码绑定企业
     * @param bindCustomerDTO bindCustomerDTO
     * @return OK
     */
    submitCustomerOauth(bindCustomerDTO: BindCustomerDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/bind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bindCustomerDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmitCustomerOauth(_response);
        });
    }

    protected processSubmitCustomerOauth(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 检查客户是否绑定企业
     * @return OK
     */
    checkOauthCustomer(appid: string, code: string): Promise<CheckOauthVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/check?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined and cannot be null.");
        else
            url_ += "appid=" + encodeURIComponent("" + appid) + "&"; 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckOauthCustomer(_response);
        });
    }

    protected processCheckOauthCustomer(response: AxiosResponse): Promise<CheckOauthVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CheckOauthVO.fromJS(resultData200) : new CheckOauthVO();
            return result200;
        }
        return Promise.resolve<CheckOauthVO>(<any>null);
    }

    /**
     * 查询客户详情
     * @param id id
     * @return OK
     */
    getCustomer(id: string): Promise<CustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/customer-info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: AxiosResponse): Promise<CustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CustomerVO.fromJS(resultData200) : new CustomerVO();
            return result200;
        }
        return Promise.resolve<CustomerVO>(<any>null);
    }

    /**
     * 解绑企业
     * @param id id
     * @return OK
     */
    deleteCustomerOauth(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/unbind/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCustomerOauth(_response);
        });
    }

    protected processDeleteCustomerOauth(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取用户绑定记录
     * @param customerUserBindDTO customerUserBindDTO
     * @return OK
     */
    getUserBindRecordList(customerUserBindDTO: CustomerUserBindDTO): Promise<CustomerUserBindRecordVO[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/user-bind-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerUserBindDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserBindRecordList(_response);
        });
    }

    protected processGetUserBindRecordList(response: AxiosResponse): Promise<CustomerUserBindRecordVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerUserBindRecordVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CustomerUserBindRecordVO[]>(<any>null);
    }

    /**
     * 获取用户信息
     * @param openid openid
     * @return OK
     */
    getUserInfo(openid: string): Promise<CustomerOauthUserInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-oauth/{openid}";
        if (openid === undefined || openid === null)
            throw new Error("The parameter 'openid' must be defined.");
        url_ = url_.replace("{openid}", encodeURIComponent("" + openid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<CustomerOauthUserInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CustomerOauthUserInfoVO.fromJS(resultData200) : new CustomerOauthUserInfoVO();
            return result200;
        }
        return Promise.resolve<CustomerOauthUserInfoVO>(<any>null);
    }
}

export class CustomerRoleServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 授权
     * @param customerRoleGrantDTO customerRoleGrantDTO
     * @return OK
     */
    grant(customerRoleGrantDTO: CustomerRoleGrantDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-role/grant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerRoleGrantDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrant(_response);
        });
    }

    protected processGrant(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class CustomerUserApplicationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param customerUserApplicationSelectDTO customerUserApplicationSelectDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, customerUserApplicationSelectDTO: CustomerUserApplicationSelectDTO, size: number | null | undefined): Promise<IPageOfCustomerUserApplicationVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-user-application/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerUserApplicationSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfCustomerUserApplicationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerUserApplicationVO.fromJS(resultData200) : new IPageOfCustomerUserApplicationVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerUserApplicationVO>(<any>null);
    }

    /**
     * 处理用户绑定申请
     * @param customerUserApplicationProcessDTO customerUserApplicationProcessDTO
     * @return OK
     */
    process(customerUserApplicationProcessDTO: CustomerUserApplicationProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customer-user-application/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerUserApplicationProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class CustomerServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增客户
     * @param dto dto
     * @return OK
     */
    createCustomer(dto: CustomerSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除客户
     * @param ids 客户ids
     * @return OK
     */
    deleteSupplier(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteSupplier(_response);
        });
    }

    protected processDeleteSupplier(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询客户（包含已删除的）
     * @param allCustomerSelectDTO allCustomerSelectDTO
     * @return OK
     */
    getAllCustomerSelectList(allCustomerSelectDTO: AllCustomerSelectDTO): Promise<CustomerVO[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/all-select";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allCustomerSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllCustomerSelectList(_response);
        });
    }

    protected processGetAllCustomerSelectList(response: AxiosResponse): Promise<CustomerVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CustomerVO[]>(<any>null);
    }

    /**
     * 导出客户
     * @param customerExcelDTO customerExcelDTO
     * @return OK
     */
    exportCustomer(customerExcelDTO: CustomerExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportCustomer(_response);
        });
    }

    protected processExportCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出模板
     * @return OK
     */
    exportTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/export-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getCustomerUserRelation
     * @param userId (optional) 用户ID
     * @return OK
     */
    getCustomerUserRelation(userId: string | null | undefined): Promise<ROfCustomerUserRelationVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/get-customer-user-relation?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerUserRelation(_response);
        });
    }

    protected processGetCustomerUserRelation(response: AxiosResponse): Promise<ROfCustomerUserRelationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfCustomerUserRelationVO.fromJS(resultData200) : new ROfCustomerUserRelationVO();
            return result200;
        }
        return Promise.resolve<ROfCustomerUserRelationVO>(<any>null);
    }

    /**
     * 机床移动的行政客户列表
     * @return OK
     */
    getRegionCustomerDetail(): Promise<ROfListOfRegionCustomerDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/get-region-customer-detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRegionCustomerDetail(_response);
        });
    }

    protected processGetRegionCustomerDetail(response: AxiosResponse): Promise<ROfListOfRegionCustomerDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegionCustomerDetailVO.fromJS(resultData200) : new ROfListOfRegionCustomerDetailVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRegionCustomerDetailVO>(<any>null);
    }

    /**
     * 导入客户
     * @param file (optional) file
     * @return OK
     */
    importCustomer(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportCustomer(_response);
        });
    }

    protected processImportCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询客户
     * @param keyWord (optional) keyWord
     * @param tenantId (optional) tenantId
     * @return OK
     */
    getCustomers(keyWord: string | null | undefined, tenantId: string | null | undefined): Promise<CustomerVO[]> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/list?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomers(_response);
        });
    }

    protected processGetCustomers(response: AxiosResponse): Promise<CustomerVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CustomerVO[]>(<any>null);
    }

    /**
     * 客户绑定机床
     * @param customerId 客户id
     * @param workStationIds 机床ids
     * @return OK
     */
    saveWorkStationCustomer(customerId: string, workStationIds: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/machine?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        if (workStationIds === undefined || workStationIds === null)
            throw new Error("The parameter 'workStationIds' must be defined and cannot be null.");
        else
            url_ += "workStationIds=" + encodeURIComponent("" + workStationIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveWorkStationCustomer(_response);
        });
    }

    protected processSaveWorkStationCustomer(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 客户解绑机床
     * @param input input
     * @return OK
     */
    deleteWorkStationCustomer(input: DeleteCustomerWorkStationDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/machine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWorkStationCustomer(_response);
        });
    }

    protected processDeleteWorkStationCustomer(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 分页查询客户
     * @param createTimeType (optional) createTimeType
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageCustomer(createTimeType: number | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfCustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (createTimeType !== undefined)
            url_ += "createTimeType=" + encodeURIComponent("" + createTimeType) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCustomer(_response);
        });
    }
    getSettingPageCustomer(createTimeType: number | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfCustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/setting-page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (createTimeType !== undefined)
            url_ += "createTimeType=" + encodeURIComponent("" + createTimeType) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCustomer(_response);
        });
    }
    protected processGetPageCustomer(response: AxiosResponse): Promise<IPageOfCustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerVO.fromJS(resultData200) : new IPageOfCustomerVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerVO>(<any>null);
    }

    /**
     * 高级查询客户
     * @param current (optional) 当前页
     * @param dto dto
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageCustomerByCondition(current: number | null | undefined, dto: CustomerSelectDTO, size: number | null | undefined): Promise<IPageOfCustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCustomerByCondition(_response);
        });
    }

    protected processGetPageCustomerByCondition(response: AxiosResponse): Promise<IPageOfCustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerVO.fromJS(resultData200) : new IPageOfCustomerVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerVO>(<any>null);
    }

    /**
     * 根据创建时间查询客户
     * @param customerQueryDTO customerQueryDTO
     * @return OK
     */
    getCustomerByCreateTime(customerQueryDTO: CustomerQueryDTO): Promise<IPageOfCustomerInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/page-by-create-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerByCreateTime(_response);
        });
    }

    protected processGetCustomerByCreateTime(response: AxiosResponse): Promise<IPageOfCustomerInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCustomerInfoVO.fromJS(resultData200) : new IPageOfCustomerInfoVO();
            return result200;
        }
        return Promise.resolve<IPageOfCustomerInfoVO>(<any>null);
    }

    /**
     * 机床移动的客户列表
     * @param provinceName provinceName
     * @return OK
     */
    getCustomerByRegion(provinceName: string): Promise<ROfListOfRegionCustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/region/{provinceName}";
        if (provinceName === undefined || provinceName === null)
            throw new Error("The parameter 'provinceName' must be defined.");
        url_ = url_.replace("{provinceName}", encodeURIComponent("" + provinceName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerByRegion(_response);
        });
    }

    protected processGetCustomerByRegion(response: AxiosResponse): Promise<ROfListOfRegionCustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegionCustomerVO.fromJS(resultData200) : new ROfListOfRegionCustomerVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRegionCustomerVO>(<any>null);
    }

    /**
     * 新租户信息
     * @param createTenantDTO_address (optional) 联系地址
     * @param createTenantDTO_appCodeList (optional) 
     * @param createTenantDTO_classes (optional) 租户身份
     * @param createTenantDTO_contactNumber (optional) 联系电话
     * @param createTenantDTO_domain (optional) 域名地址
     * @param createTenantDTO_linkman (optional) 联系人
     * @param createTenantDTO_tenantCode (optional) 租户编号
     * @param createTenantDTO_tenantId (optional) 租户ID
     * @param createTenantDTO_tenantName (optional) 租户名称
     * @param customerId (optional) 
     * @return OK
     */
    turnToTenant(createTenantDTO_address: string | null | undefined, createTenantDTO_appCodeList: string[] | null | undefined, createTenantDTO_classes: number | null | undefined, createTenantDTO_contactNumber: string | null | undefined, createTenantDTO_domain: string | null | undefined, createTenantDTO_linkman: string | null | undefined, createTenantDTO_tenantCode: string | null | undefined, createTenantDTO_tenantId: string | null | undefined, createTenantDTO_tenantName: string | null | undefined, customerId: string | null | undefined): Promise<ROfTenantVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/turn-to-tenant?";
        if (createTenantDTO_address !== undefined)
            url_ += "createTenantDTO.address=" + encodeURIComponent("" + createTenantDTO_address) + "&"; 
        if (createTenantDTO_appCodeList !== undefined)
            createTenantDTO_appCodeList && createTenantDTO_appCodeList.forEach(item => { url_ += "createTenantDTO.appCodeList=" + encodeURIComponent("" + item) + "&"; });
        if (createTenantDTO_classes !== undefined)
            url_ += "createTenantDTO.classes=" + encodeURIComponent("" + createTenantDTO_classes) + "&"; 
        if (createTenantDTO_contactNumber !== undefined)
            url_ += "createTenantDTO.contactNumber=" + encodeURIComponent("" + createTenantDTO_contactNumber) + "&"; 
        if (createTenantDTO_domain !== undefined)
            url_ += "createTenantDTO.domain=" + encodeURIComponent("" + createTenantDTO_domain) + "&"; 
        if (createTenantDTO_linkman !== undefined)
            url_ += "createTenantDTO.linkman=" + encodeURIComponent("" + createTenantDTO_linkman) + "&"; 
        if (createTenantDTO_tenantCode !== undefined)
            url_ += "createTenantDTO.tenantCode=" + encodeURIComponent("" + createTenantDTO_tenantCode) + "&"; 
        if (createTenantDTO_tenantId !== undefined)
            url_ += "createTenantDTO.tenantId=" + encodeURIComponent("" + createTenantDTO_tenantId) + "&"; 
        if (createTenantDTO_tenantName !== undefined)
            url_ += "createTenantDTO.tenantName=" + encodeURIComponent("" + createTenantDTO_tenantName) + "&"; 
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTurnToTenant(_response);
        });
    }

    protected processTurnToTenant(response: AxiosResponse): Promise<ROfTenantVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfTenantVO.fromJS(resultData200) : new ROfTenantVO();
            return result200;
        }
        return Promise.resolve<ROfTenantVO>(<any>null);
    }

    /**
     * updateCustomerUserRelation
     * @param customerUserRelationDTO customerUserRelationDTO
     * @return OK
     */
    updateCustomerUserRelation(customerUserRelationDTO: CustomerUserRelationDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/update-customer-user-relation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerUserRelationDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCustomerUserRelation(_response);
        });
    }

    protected processUpdateCustomerUserRelation(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 查询客户详情
     * @param id id
     * @return OK
     */
    getCustomer(id: string): Promise<CustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: AxiosResponse): Promise<CustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CustomerVO.fromJS(resultData200) : new CustomerVO();
            return result200;
        }
        return Promise.resolve<CustomerVO>(<any>null);
    }

    /**
     * 编辑客户信息
     * @param dto dto
     * @param id 客户id
     * @return OK
     */
    updateSupplier(dto: CustomerSubmitDTO, id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSupplier(_response);
        });
    }

    protected processUpdateSupplier(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class SupplierServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增供应商
     * @param dto dto
     * @return OK
     */
    createSupplier(dto: SupplierSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateSupplier(_response);
        });
    }

    protected processCreateSupplier(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除供应商
     * @param ids 供应商ids
     * @return OK
     */
    deleteSupplier(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteSupplier(_response);
        });
    }

    protected processDeleteSupplier(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询供应商
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageSupplier(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfSupplierVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageSupplier(_response);
        });
    }

    protected processGetPageSupplier(response: AxiosResponse): Promise<IPageOfSupplierVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfSupplierVO.fromJS(resultData200) : new IPageOfSupplierVO();
            return result200;
        }
        return Promise.resolve<IPageOfSupplierVO>(<any>null);
    }

    /**
     * 分页查询供应商
     * @param ascs (optional) 
     * @param current (optional) 
     * @param descs (optional) 
     * @param keyWord (optional) 
     * @param size (optional) 
     * @return OK
     */
    getPageSupplierIsv(ascs: string | null | undefined, current: number | null | undefined, descs: string | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfSupplierVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers/pageIsv?";
        if (ascs !== undefined)
            url_ += "ascs=" + encodeURIComponent("" + ascs) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (descs !== undefined)
            url_ += "descs=" + encodeURIComponent("" + descs) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageSupplierIsv(_response);
        });
    }

    protected processGetPageSupplierIsv(response: AxiosResponse): Promise<IPageOfSupplierVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfSupplierVO.fromJS(resultData200) : new IPageOfSupplierVO();
            return result200;
        }
        return Promise.resolve<IPageOfSupplierVO>(<any>null);
    }

    /**
     * 查询供应商详情
     * @param id (optional) 供应商id
     * @return OK
     */
    getSupplier(id: string | null | undefined): Promise<SupplierVO> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSupplier(_response);
        });
    }

    protected processGetSupplier(response: AxiosResponse): Promise<SupplierVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SupplierVO.fromJS(resultData200) : new SupplierVO();
            return result200;
        }
        return Promise.resolve<SupplierVO>(<any>null);
    }

    /**
     * 编辑供应商信息
     * @param dto dto
     * @param id 供应商id
     * @return OK
     */
    updateSupplier(dto: SupplierSubmitDTO, id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www.masterlink.cloud/masterlink-cps-client')+ "/suppliers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSupplier(_response);
        });
    }

    protected processUpdateSupplier(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AllCustomerSelectDTO implements IAllCustomerSelectDTO {
    /** 大区名称 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: IAllCustomerSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.keyWord = data["keyWord"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): AllCustomerSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AllCustomerSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["keyWord"] = this.keyWord;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface IAllCustomerSelectDTO {
    /** 大区名称 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class BindCustomerDTO implements IBindCustomerDTO {
    /** appid */
    appid!: string | undefined;
    /** 头像 */
    avatar!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** 昵称 */
    nickName!: string | undefined;
    /** openid */
    openid!: string | undefined;
    /** 联系方式 */
    phone!: string | undefined;
    /** unionid */
    unionid!: string | undefined;
    /** 用户名 */
    userName!: string | undefined;

    constructor(data?: IBindCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appid = data["appid"];
            this.avatar = data["avatar"];
            this.customerId = data["customerId"];
            this.id = data["id"];
            this.nickName = data["nickName"];
            this.openid = data["openid"];
            this.phone = data["phone"];
            this.unionid = data["unionid"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): BindCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BindCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appid"] = this.appid;
        data["avatar"] = this.avatar;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["nickName"] = this.nickName;
        data["openid"] = this.openid;
        data["phone"] = this.phone;
        data["unionid"] = this.unionid;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IBindCustomerDTO {
    /** appid */
    appid: string | undefined;
    /** 头像 */
    avatar: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** ID */
    id: string | undefined;
    /** 昵称 */
    nickName: string | undefined;
    /** openid */
    openid: string | undefined;
    /** 联系方式 */
    phone: string | undefined;
    /** unionid */
    unionid: string | undefined;
    /** 用户名 */
    userName: string | undefined;
}

export class BindCustomerVO implements IBindCustomerVO {
    /** 客户ID */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;

    constructor(data?: IBindCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
        }
    }

    static fromJS(data: any): BindCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new BindCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        return data; 
    }
}

export interface IBindCustomerVO {
    /** 客户ID */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
}

export class CheckOauthVO implements ICheckOauthVO {
    /** 绑定企业的用户信息 */
    customerOauth!: CustomerOauth | undefined;
    /** openid */
    openid!: string | undefined;
    /** sessionKey */
    sessionKey!: string | undefined;
    /** unionid */
    unionid!: string | undefined;

    constructor(data?: ICheckOauthVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerOauth = data["customerOauth"] ? CustomerOauth.fromJS(data["customerOauth"]) : <any>undefined;
            this.openid = data["openid"];
            this.sessionKey = data["sessionKey"];
            this.unionid = data["unionid"];
        }
    }

    static fromJS(data: any): CheckOauthVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOauthVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerOauth"] = this.customerOauth ? this.customerOauth.toJSON() : <any>undefined;
        data["openid"] = this.openid;
        data["sessionKey"] = this.sessionKey;
        data["unionid"] = this.unionid;
        return data; 
    }
}

export interface ICheckOauthVO {
    /** 绑定企业的用户信息 */
    customerOauth: CustomerOauth | undefined;
    /** openid */
    openid: string | undefined;
    /** sessionKey */
    sessionKey: string | undefined;
    /** unionid */
    unionid: string | undefined;
}

export class CustomerApplicationInsertDTO implements ICustomerApplicationInsertDTO {
    /** 详细地址 */
    address!: string;
    /** appid */
    appid!: string;
    /** 大区 */
    areaName!: string;
    /** 城市 */
    cityName!: string;
    /** code */
    code!: string;
    /** 上报人 */
    contact!: string;
    /** 设备型号 */
    deviceTypeName!: string;
    /** 客户名称 */
    name!: string;
    /** 省份 */
    provinceName!: string;
    /** 设备序列号 */
    serialNo!: string;
    /** 联系方式 */
    tel!: string;
    /** tenantId */
    tenantId!: string;

    constructor(data?: ICustomerApplicationInsertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.appid = data["appid"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.code = data["code"];
            this.contact = data["contact"];
            this.deviceTypeName = data["deviceTypeName"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
            this.serialNo = data["serialNo"];
            this.tel = data["tel"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CustomerApplicationInsertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApplicationInsertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["appid"] = this.appid;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["code"] = this.code;
        data["contact"] = this.contact;
        data["deviceTypeName"] = this.deviceTypeName;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        data["serialNo"] = this.serialNo;
        data["tel"] = this.tel;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICustomerApplicationInsertDTO {
    /** 详细地址 */
    address: string;
    /** appid */
    appid: string;
    /** 大区 */
    areaName: string;
    /** 城市 */
    cityName: string;
    /** code */
    code: string;
    /** 上报人 */
    contact: string;
    /** 设备型号 */
    deviceTypeName: string;
    /** 客户名称 */
    name: string;
    /** 省份 */
    provinceName: string;
    /** 设备序列号 */
    serialNo: string;
    /** 联系方式 */
    tel: string;
    /** tenantId */
    tenantId: string;
}

export class CustomerApplicationProcessDTO implements ICustomerApplicationProcessDTO {
    /** 评论 */
    comment!: string | undefined;
    /** id */
    id!: string;
    /** 状态 */
    status!: number;

    constructor(data?: ICustomerApplicationProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comment = data["comment"];
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CustomerApplicationProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApplicationProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["id"] = this.id;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomerApplicationProcessDTO {
    /** 评论 */
    comment: string | undefined;
    /** id */
    id: string;
    /** 状态 */
    status: number;
}

export class CustomerApplicationSelectDTO implements ICustomerApplicationSelectDTO {
    /** 关键词 */
    keyWord!: string | undefined;
    /** 状态列表 */
    statusList!: number[] | undefined;

    constructor(data?: ICustomerApplicationSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyWord = data["keyWord"];
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerApplicationSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApplicationSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface ICustomerApplicationSelectDTO {
    /** 关键词 */
    keyWord: string | undefined;
    /** 状态列表 */
    statusList: number[] | undefined;
}

export class CustomerApplicationVO implements ICustomerApplicationVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 单据号 */
    code!: string | undefined;
    /** 上报人 */
    contact!: string | undefined;
    /** 提交时间 */
    createTime!: Date | undefined;
    /** 设备型号 */
    deviceTypeName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 客户名称 */
    name!: string | undefined;
    /** 省份 */
    provinceName!: string | undefined;
    /** 设备序列号 */
    serialNo!: string | undefined;
    /** 状态: 1:待处理 2:已创建 3:已拒绝 */
    status!: number | undefined;
    /** 联系方式 */
    tel!: string | undefined;

    constructor(data?: ICustomerApplicationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.code = data["code"];
            this.contact = data["contact"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
            this.serialNo = data["serialNo"];
            this.status = data["status"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): CustomerApplicationVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApplicationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["code"] = this.code;
        data["contact"] = this.contact;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        data["serialNo"] = this.serialNo;
        data["status"] = this.status;
        data["tel"] = this.tel;
        return data; 
    }
}

export interface ICustomerApplicationVO {
    /** 详细地址 */
    address: string | undefined;
    /** 单据号 */
    code: string | undefined;
    /** 上报人 */
    contact: string | undefined;
    /** 提交时间 */
    createTime: Date | undefined;
    /** 设备型号 */
    deviceTypeName: string | undefined;
    /** id */
    id: string | undefined;
    /** 客户名称 */
    name: string | undefined;
    /** 省份 */
    provinceName: string | undefined;
    /** 设备序列号 */
    serialNo: string | undefined;
    /** 状态: 1:待处理 2:已创建 3:已拒绝 */
    status: number | undefined;
    /** 联系方式 */
    tel: string | undefined;
}

export class CustomerExcelDTO implements ICustomerExcelDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 开始时间 */
    beginTime!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 结束时间 */
    endTime!: string | undefined;
    /** host */
    host!: string | undefined;
    /** 所选中的列表数据 */
    idList!: string[] | undefined;
    /** 是否为高级查询 */
    isAdvance!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 客户名称 */
    name!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.beginTime = data["beginTime"];
            this.cityName = data["cityName"];
            this.endTime = data["endTime"];
            this.host = data["host"];
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.isAdvance = data["isAdvance"];
            this.keyWord = data["keyWord"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["beginTime"] = this.beginTime;
        data["cityName"] = this.cityName;
        data["endTime"] = this.endTime;
        data["host"] = this.host;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["isAdvance"] = this.isAdvance;
        data["keyWord"] = this.keyWord;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerExcelDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 开始时间 */
    beginTime: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 结束时间 */
    endTime: string | undefined;
    /** host */
    host: string | undefined;
    /** 所选中的列表数据 */
    idList: string[] | undefined;
    /** 是否为高级查询 */
    isAdvance: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 客户名称 */
    name: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class CustomerHistoryAddressSelectDTO implements ICustomerHistoryAddressSelectDTO {
    /** 客户ID */
    customerId!: string | undefined;
    /** 关键词 */
    keyWord!: string | undefined;

    constructor(data?: ICustomerHistoryAddressSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.keyWord = data["keyWord"];
        }
    }

    static fromJS(data: any): CustomerHistoryAddressSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerHistoryAddressSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["keyWord"] = this.keyWord;
        return data; 
    }
}

export interface ICustomerHistoryAddressSelectDTO {
    /** 客户ID */
    customerId: string | undefined;
    /** 关键词 */
    keyWord: string | undefined;
}

export class CustomerHistoryAddressSubmitDTO implements ICustomerHistoryAddressSubmitDTO {
    address!: string | undefined;
    areaName!: string | undefined;
    cityName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** ID */
    id!: string | undefined;
    provinceName!: string | undefined;

    constructor(data?: ICustomerHistoryAddressSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.customerId = data["customerId"];
            this.id = data["id"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerHistoryAddressSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerHistoryAddressSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerHistoryAddressSubmitDTO {
    address: string | undefined;
    areaName: string | undefined;
    cityName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** ID */
    id: string | undefined;
    provinceName: string | undefined;
}

export class CustomerHistoryAddressVO implements ICustomerHistoryAddressVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 大区名称 */
    areaName!: string | undefined;
    /** 市级编码 */
    cityCode!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** 省级编码 */
    provinceCode!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerHistoryAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityCode = data["cityCode"];
            this.cityName = data["cityName"];
            this.customerId = data["customerId"];
            this.id = data["id"];
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerHistoryAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerHistoryAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityCode"] = this.cityCode;
        data["cityName"] = this.cityName;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerHistoryAddressVO {
    /** 详细地址 */
    address: string | undefined;
    /** 大区名称 */
    areaName: string | undefined;
    /** 市级编码 */
    cityCode: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** ID */
    id: string | undefined;
    /** 省级编码 */
    provinceCode: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class CustomerInfoVO implements ICustomerInfoVO {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 客户ID */
    id!: string | undefined;
    /** 客户名称 */
    name!: string | undefined;

    constructor(data?: ICustomerInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CustomerInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICustomerInfoVO {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 客户ID */
    id: string | undefined;
    /** 客户名称 */
    name: string | undefined;
}

export class CustomerMenuVO implements ICustomerMenuVO {
    children!: CustomerMenuVO[] | undefined;
    /** 菜单编号 */
    code!: string | undefined;
    hasChildren!: boolean | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 菜单名称 */
    name!: string | undefined;
    /** 父节点ID */
    parentId!: string | undefined;

    constructor(data?: ICustomerMenuVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(CustomerMenuVO.fromJS(item));
            }
            this.code = data["code"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): CustomerMenuVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMenuVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface ICustomerMenuVO {
    children: CustomerMenuVO[] | undefined;
    /** 菜单编号 */
    code: string | undefined;
    hasChildren: boolean | undefined;
    /** 主键 */
    id: string | undefined;
    /** 菜单名称 */
    name: string | undefined;
    /** 父节点ID */
    parentId: string | undefined;
}

export class CustomerOauth implements ICustomerOauth {
    appid!: string | undefined;
    avatar!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    customerId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    nickName!: string | undefined;
    openid!: string | undefined;
    phone!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    unionid!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ICustomerOauth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appid = data["appid"];
            this.avatar = data["avatar"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.customerId = data["customerId"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.nickName = data["nickName"];
            this.openid = data["openid"];
            this.phone = data["phone"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.unionid = data["unionid"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CustomerOauth {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOauth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appid"] = this.appid;
        data["avatar"] = this.avatar;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["nickName"] = this.nickName;
        data["openid"] = this.openid;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["unionid"] = this.unionid;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICustomerOauth {
    appid: string | undefined;
    avatar: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    customerId: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    nickName: string | undefined;
    openid: string | undefined;
    phone: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    unionid: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    userName: string | undefined;
}

export class CustomerOauthUserInfoVO implements ICustomerOauthUserInfoVO {
    /** 地址 */
    address!: string | undefined;
    /** 头像 */
    avatar!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 客户id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 区级名称 */
    districtName!: string | undefined;
    id!: string | undefined;
    /** 昵称 */
    nickName!: string | undefined;
    /** 联系方式 */
    phone!: string | undefined;
    /** 省份 */
    provinceName!: string | undefined;
    /** 租户id */
    tenantId!: string | undefined;
    /** 上报人 */
    userName!: string | undefined;

    constructor(data?: ICustomerOauthUserInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.avatar = data["avatar"];
            this.cityName = data["cityName"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.districtName = data["districtName"];
            this.id = data["id"];
            this.nickName = data["nickName"];
            this.phone = data["phone"];
            this.provinceName = data["provinceName"];
            this.tenantId = data["tenantId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CustomerOauthUserInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOauthUserInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["avatar"] = this.avatar;
        data["cityName"] = this.cityName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["districtName"] = this.districtName;
        data["id"] = this.id;
        data["nickName"] = this.nickName;
        data["phone"] = this.phone;
        data["provinceName"] = this.provinceName;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICustomerOauthUserInfoVO {
    /** 地址 */
    address: string | undefined;
    /** 头像 */
    avatar: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 客户id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 区级名称 */
    districtName: string | undefined;
    id: string | undefined;
    /** 昵称 */
    nickName: string | undefined;
    /** 联系方式 */
    phone: string | undefined;
    /** 省份 */
    provinceName: string | undefined;
    /** 租户id */
    tenantId: string | undefined;
    /** 上报人 */
    userName: string | undefined;
}

export class CustomerQueryDTO implements ICustomerQueryDTO {
    /** 创建时间类型 */
    createTimeType!: number | undefined;
    query!: Query | undefined;

    constructor(data?: ICustomerQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTimeType = data["createTimeType"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTimeType"] = this.createTimeType;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerQueryDTO {
    /** 创建时间类型 */
    createTimeType: number | undefined;
    query: Query | undefined;
}

export class CustomerRoleGrantDTO implements ICustomerRoleGrantDTO {
    /** 客户ID */
    customerId!: string | undefined;
    /** 菜单ID列表 */
    menuIds!: string[] | undefined;

    constructor(data?: ICustomerRoleGrantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            if (data["menuIds"] && data["menuIds"].constructor === Array) {
                this.menuIds = [] as any;
                for (let item of data["menuIds"])
                    this.menuIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerRoleGrantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRoleGrantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (this.menuIds && this.menuIds.constructor === Array) {
            data["menuIds"] = [];
            for (let item of this.menuIds)
                data["menuIds"].push(item);
        }
        return data; 
    }
}

export interface ICustomerRoleGrantDTO {
    /** 客户ID */
    customerId: string | undefined;
    /** 菜单ID列表 */
    menuIds: string[] | undefined;
}

export class CustomerSelectDTO implements ICustomerSelectDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 开始时间 */
    beginTime!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 结束时间 */
    endTime!: string | undefined;
    /** 客户名称 */
    name!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.beginTime = data["beginTime"];
            this.cityName = data["cityName"];
            this.endTime = data["endTime"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["beginTime"] = this.beginTime;
        data["cityName"] = this.cityName;
        data["endTime"] = this.endTime;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerSelectDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 开始时间 */
    beginTime: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 结束时间 */
    endTime: string | undefined;
    /** 客户名称 */
    name: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class CustomerSubmitDTO implements ICustomerSubmitDTO {
    /** 客户地址 */
    address!: string | undefined;
    /** 地理大区名称 */
    areaName!: string;
    /** 市级名称 */
    cityName!: string;
    /** 客户编码 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 联系人 */
    contact!: string | undefined;
    /** 职权域 */
    createDept!: string;
    /** 区级名称 */
    districtName!: string;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 是否小程序 */
    isMini!: number | undefined;
    /** 客户名称 */
    name!: string;
    /** 省级名称 */
    provinceName!: string;
    /** 联系方式 */
    tel!: string | undefined;

    constructor(data?: ICustomerSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.contact = data["contact"];
            this.createDept = data["createDept"];
            this.districtName = data["districtName"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.isMini = data["isMini"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): CustomerSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["contact"] = this.contact;
        data["createDept"] = this.createDept;
        data["districtName"] = this.districtName;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["isMini"] = this.isMini;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        data["tel"] = this.tel;
        return data; 
    }
}

export interface ICustomerSubmitDTO {
    /** 客户地址 */
    address: string | undefined;
    /** 地理大区名称 */
    areaName: string;
    /** 市级名称 */
    cityName: string;
    /** 客户编码 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 联系人 */
    contact: string | undefined;
    /** 职权域 */
    createDept: string;
    /** 区级名称 */
    districtName: string;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 是否小程序 */
    isMini: number | undefined;
    /** 客户名称 */
    name: string;
    /** 省级名称 */
    provinceName: string;
    /** 联系方式 */
    tel: string | undefined;
}

export class CustomerUserApplicationProcessDTO implements ICustomerUserApplicationProcessDTO {
    /** ids */
    ids!: string[];
    /** 状态 */
    status!: number;

    constructor(data?: ICustomerUserApplicationProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CustomerUserApplicationProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserApplicationProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomerUserApplicationProcessDTO {
    /** ids */
    ids: string[];
    /** 状态 */
    status: number;
}

export class CustomerUserApplicationSelectDTO implements ICustomerUserApplicationSelectDTO {
    /** 关键词 */
    keyWord!: string | undefined;
    /** 状态列表 */
    statusList!: number[] | undefined;

    constructor(data?: ICustomerUserApplicationSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyWord = data["keyWord"];
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerUserApplicationSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserApplicationSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface ICustomerUserApplicationSelectDTO {
    /** 关键词 */
    keyWord: string | undefined;
    /** 状态列表 */
    statusList: number[] | undefined;
}

export class CustomerUserApplicationVO implements ICustomerUserApplicationVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 绑定次数 */
    bindNum!: number | undefined;
    /** 单据号 */
    code!: string | undefined;
    /** 提交时间 */
    createTime!: Date | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** openid */
    openid!: string | undefined;
    /** 联系方式 */
    phone!: string | undefined;
    /** 省份 */
    provinceName!: string | undefined;
    /** 状态: 1:待处理 2:已创建 3:已拒绝 */
    status!: number | undefined;
    /** 上报人 */
    userName!: string | undefined;

    constructor(data?: ICustomerUserApplicationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.bindNum = data["bindNum"];
            this.code = data["code"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.customerName = data["customerName"];
            this.id = data["id"];
            this.openid = data["openid"];
            this.phone = data["phone"];
            this.provinceName = data["provinceName"];
            this.status = data["status"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CustomerUserApplicationVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserApplicationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["bindNum"] = this.bindNum;
        data["code"] = this.code;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["id"] = this.id;
        data["openid"] = this.openid;
        data["phone"] = this.phone;
        data["provinceName"] = this.provinceName;
        data["status"] = this.status;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICustomerUserApplicationVO {
    /** 详细地址 */
    address: string | undefined;
    /** 绑定次数 */
    bindNum: number | undefined;
    /** 单据号 */
    code: string | undefined;
    /** 提交时间 */
    createTime: Date | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** id */
    id: string | undefined;
    /** openid */
    openid: string | undefined;
    /** 联系方式 */
    phone: string | undefined;
    /** 省份 */
    provinceName: string | undefined;
    /** 状态: 1:待处理 2:已创建 3:已拒绝 */
    status: number | undefined;
    /** 上报人 */
    userName: string | undefined;
}

export class CustomerUserBindDTO implements ICustomerUserBindDTO {
    /** 提交时间 */
    createTime!: Date;
    /** openid */
    openid!: string;

    constructor(data?: ICustomerUserBindDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.openid = data["openid"];
        }
    }

    static fromJS(data: any): CustomerUserBindDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserBindDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["openid"] = this.openid;
        return data; 
    }
}

export interface ICustomerUserBindDTO {
    /** 提交时间 */
    createTime: Date;
    /** openid */
    openid: string;
}

export class CustomerUserBindRecordVO implements ICustomerUserBindRecordVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 提交时间 */
    createTime!: Date | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 省份 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerUserBindRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerUserBindRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserBindRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerUserBindRecordVO {
    /** 详细地址 */
    address: string | undefined;
    /** 提交时间 */
    createTime: Date | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 省份 */
    provinceName: string | undefined;
}

export class CustomerUserRelationDTO implements ICustomerUserRelationDTO {
    /** 绑定客户ID */
    customerIds!: string[] | undefined;
    /** 用户ID */
    userId!: string | undefined;

    constructor(data?: ICustomerUserRelationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [] as any;
                for (let item of data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): CustomerUserRelationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserRelationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["userId"] = this.userId;
        return data; 
    }
}

export interface ICustomerUserRelationDTO {
    /** 绑定客户ID */
    customerIds: string[] | undefined;
    /** 用户ID */
    userId: string | undefined;
}

export class CustomerUserRelationVO implements ICustomerUserRelationVO {
    /** 绑定客户ID */
    customerUser!: BindCustomerVO[] | undefined;
    /** 用户ID */
    userId!: string | undefined;

    constructor(data?: ICustomerUserRelationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerUser"] && data["customerUser"].constructor === Array) {
                this.customerUser = [] as any;
                for (let item of data["customerUser"])
                    this.customerUser!.push(BindCustomerVO.fromJS(item));
            }
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): CustomerUserRelationVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserRelationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerUser && this.customerUser.constructor === Array) {
            data["customerUser"] = [];
            for (let item of this.customerUser)
                data["customerUser"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        return data; 
    }
}

export interface ICustomerUserRelationVO {
    /** 绑定客户ID */
    customerUser: BindCustomerVO[] | undefined;
    /** 用户ID */
    userId: string | undefined;
}

/** 客户信息 */
export class CustomerVO implements ICustomerVO {
    /** 客户地址 */
    address!: string | undefined;
    /** 地理大区名称 */
    areaName!: string | undefined;
    /** 市级编码 */
    cityCode!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 客户编码 */
    code!: string | undefined;
    /** 联系方式 */
    contact!: string | undefined;
    /** 职权域 */
    createDept!: string | undefined;
    /** 客户新建了自定义机床的标识 */
    customMachine!: boolean | undefined;
    /** 区级名称 */
    districtName!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 客户名称 */
    name!: string | undefined;
    /** 客户名称拼音首字母 */
    namePinyinShort!: string | undefined;
    /** 省级编码 */
    provinceCode!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 关联租户编号 */
    relatedTenantCode!: string | undefined;
    /** 关联租户id */
    relatedTenantId!: string | undefined;
    /** 联系方式 */
    tel!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: ICustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityCode = data["cityCode"];
            this.cityName = data["cityName"];
            this.code = data["code"];
            this.contact = data["contact"];
            this.createDept = data["createDept"];
            this.customMachine = data["customMachine"];
            this.districtName = data["districtName"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.namePinyinShort = data["namePinyinShort"];
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
            this.relatedTenantCode = data["relatedTenantCode"];
            this.relatedTenantId = data["relatedTenantId"];
            this.tel = data["tel"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityCode"] = this.cityCode;
        data["cityName"] = this.cityName;
        data["code"] = this.code;
        data["contact"] = this.contact;
        data["createDept"] = this.createDept;
        data["customMachine"] = this.customMachine;
        data["districtName"] = this.districtName;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["namePinyinShort"] = this.namePinyinShort;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["relatedTenantCode"] = this.relatedTenantCode;
        data["relatedTenantId"] = this.relatedTenantId;
        data["tel"] = this.tel;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** 客户信息 */
export interface ICustomerVO {
    /** 客户地址 */
    address: string | undefined;
    /** 地理大区名称 */
    areaName: string | undefined;
    /** 市级编码 */
    cityCode: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 客户编码 */
    code: string | undefined;
    /** 联系方式 */
    contact: string | undefined;
    /** 职权域 */
    createDept: string | undefined;
    /** 客户新建了自定义机床的标识 */
    customMachine: boolean | undefined;
    /** 区级名称 */
    districtName: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 客户名称 */
    name: string | undefined;
    /** 客户名称拼音首字母 */
    namePinyinShort: string | undefined;
    /** 省级编码 */
    provinceCode: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 关联租户编号 */
    relatedTenantCode: string | undefined;
    /** 关联租户id */
    relatedTenantId: string | undefined;
    /** 联系方式 */
    tel: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class CustomerWorkStationDTO implements ICustomerWorkStationDTO {
    customerId!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: ICustomerWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): CustomerWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface ICustomerWorkStationDTO {
    customerId: string | undefined;
    workStationId: string | undefined;
}

export class DeleteCustomerWorkStationDTO implements IDeleteCustomerWorkStationDTO {
    customerWorkStationList!: CustomerWorkStationDTO[] | undefined;

    constructor(data?: IDeleteCustomerWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerWorkStationList"] && data["customerWorkStationList"].constructor === Array) {
                this.customerWorkStationList = [] as any;
                for (let item of data["customerWorkStationList"])
                    this.customerWorkStationList!.push(CustomerWorkStationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteCustomerWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomerWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerWorkStationList && this.customerWorkStationList.constructor === Array) {
            data["customerWorkStationList"] = [];
            for (let item of this.customerWorkStationList)
                data["customerWorkStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeleteCustomerWorkStationDTO {
    customerWorkStationList: CustomerWorkStationDTO[] | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfCustomerApplicationVO implements IIPageOfCustomerApplicationVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerApplicationVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerApplicationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerApplicationVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerApplicationVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerApplicationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerApplicationVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerApplicationVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCustomerHistoryAddressVO implements IIPageOfCustomerHistoryAddressVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerHistoryAddressVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerHistoryAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerHistoryAddressVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerHistoryAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerHistoryAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerHistoryAddressVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerHistoryAddressVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCustomerInfoVO implements IIPageOfCustomerInfoVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerInfoVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerInfoVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerInfoVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerInfoVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCustomerUserApplicationVO implements IIPageOfCustomerUserApplicationVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerUserApplicationVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerUserApplicationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerUserApplicationVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerUserApplicationVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerUserApplicationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerUserApplicationVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerUserApplicationVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfCustomerVO implements IIPageOfCustomerVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CustomerVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CustomerVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCustomerVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CustomerVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfSupplierVO implements IIPageOfSupplierVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: SupplierVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfSupplierVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(SupplierVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfSupplierVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfSupplierVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfSupplierVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: SupplierVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfCustomerHistoryAddressVO implements IROfCustomerHistoryAddressVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: CustomerHistoryAddressVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfCustomerHistoryAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? CustomerHistoryAddressVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfCustomerHistoryAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfCustomerHistoryAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfCustomerHistoryAddressVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: CustomerHistoryAddressVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfCustomerUserRelationVO implements IROfCustomerUserRelationVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: CustomerUserRelationVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfCustomerUserRelationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? CustomerUserRelationVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfCustomerUserRelationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfCustomerUserRelationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfCustomerUserRelationVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: CustomerUserRelationVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfCustomerHistoryAddressVO implements IROfIPageOfCustomerHistoryAddressVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfCustomerHistoryAddressVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfCustomerHistoryAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfCustomerHistoryAddressVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfCustomerHistoryAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfCustomerHistoryAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfCustomerHistoryAddressVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfCustomerHistoryAddressVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfRegionCustomerDetailVO implements IROfListOfRegionCustomerDetailVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RegionCustomerDetailVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfRegionCustomerDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(RegionCustomerDetailVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfRegionCustomerDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfRegionCustomerDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfRegionCustomerDetailVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RegionCustomerDetailVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfRegionCustomerVO implements IROfListOfRegionCustomerVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RegionCustomerVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfRegionCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(RegionCustomerVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfRegionCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfRegionCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfRegionCustomerVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RegionCustomerVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfTenantVO implements IROfTenantVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TenantVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfTenantVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? TenantVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfTenantVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfTenantVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfTenantVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TenantVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RegionCustomerDetailVO implements IRegionCustomerDetailVO {
    /** 子集 */
    children!: RegionCustomerDetailVO[] | undefined;
    /** 主键 */
    code!: string | undefined;
    /** 标记位 */
    flag!: boolean | undefined;
    /** 层级 */
    level!: number | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 父级编码 */
    parentCode!: string | undefined;
    /** 父级名称 */
    parentName!: string | undefined;

    constructor(data?: IRegionCustomerDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(RegionCustomerDetailVO.fromJS(item));
            }
            this.code = data["code"];
            this.flag = data["flag"];
            this.level = data["level"];
            this.name = data["name"];
            this.parentCode = data["parentCode"];
            this.parentName = data["parentName"];
        }
    }

    static fromJS(data: any): RegionCustomerDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionCustomerDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["flag"] = this.flag;
        data["level"] = this.level;
        data["name"] = this.name;
        data["parentCode"] = this.parentCode;
        data["parentName"] = this.parentName;
        return data; 
    }
}

export interface IRegionCustomerDetailVO {
    /** 子集 */
    children: RegionCustomerDetailVO[] | undefined;
    /** 主键 */
    code: string | undefined;
    /** 标记位 */
    flag: boolean | undefined;
    /** 层级 */
    level: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 父级编码 */
    parentCode: string | undefined;
    /** 父级名称 */
    parentName: string | undefined;
}

export class RegionCustomerVO implements IRegionCustomerVO {
    /** 客户编码 */
    code!: string | undefined;
    /** 标记位 */
    flag!: boolean | undefined;
    /** 客户id */
    id!: string | undefined;
    /** 客户名称 */
    name!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: IRegionCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.flag = data["flag"];
            this.id = data["id"];
            this.name = data["name"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): RegionCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["flag"] = this.flag;
        data["id"] = this.id;
        data["name"] = this.name;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface IRegionCustomerVO {
    /** 客户编码 */
    code: string | undefined;
    /** 标记位 */
    flag: boolean | undefined;
    /** 客户id */
    id: string | undefined;
    /** 客户名称 */
    name: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class SupplierSubmitDTO implements ISupplierSubmitDTO {
    /** 供应商地址 */
    address!: string | undefined;
    /** 供应商编码 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 供应商名称 */
    name!: string;
    /** 联系方式 */
    tel!: string | undefined;

    constructor(data?: ISupplierSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): SupplierSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }
}

export interface ISupplierSubmitDTO {
    /** 供应商地址 */
    address: string | undefined;
    /** 供应商编码 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 供应商名称 */
    name: string;
    /** 联系方式 */
    tel: string | undefined;
}

/** 供应商信息 */
export class SupplierVO implements ISupplierVO {
    /** 供应商地址 */
    address!: string | undefined;
    /** 供应商编码 */
    code!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 供应商名称 */
    name!: string | undefined;
    /** 联系方式 */
    tel!: string | undefined;

    constructor(data?: ISupplierVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.code = data["code"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): SupplierVO {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["code"] = this.code;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 供应商信息 */
export interface ISupplierVO {
    /** 供应商地址 */
    address: string | undefined;
    /** 供应商编码 */
    code: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 供应商名称 */
    name: string | undefined;
    /** 联系方式 */
    tel: string | undefined;
}

export class TenantVO implements ITenantVO {
    /** 账号额度 */
    accountNumber!: number | undefined;
    /** 联系地址 */
    address!: string | undefined;
    /** 系统背景 */
    backgroundUrl!: string | undefined;
    /** 租户身份 */
    classes!: number | undefined;
    /** 联系电话 */
    contactNumber!: string | undefined;
    /** 域名地址 */
    domain!: string | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 联系人 */
    linkman!: string | undefined;
    /** 租户编号 */
    tenantCode!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 租户名称 */
    tenantName!: string | undefined;

    constructor(data?: ITenantVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.address = data["address"];
            this.backgroundUrl = data["backgroundUrl"];
            this.classes = data["classes"];
            this.contactNumber = data["contactNumber"];
            this.domain = data["domain"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.linkman = data["linkman"];
            this.tenantCode = data["tenantCode"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): TenantVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address;
        data["backgroundUrl"] = this.backgroundUrl;
        data["classes"] = this.classes;
        data["contactNumber"] = this.contactNumber;
        data["domain"] = this.domain;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["linkman"] = this.linkman;
        data["tenantCode"] = this.tenantCode;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface ITenantVO {
    /** 账号额度 */
    accountNumber: number | undefined;
    /** 联系地址 */
    address: string | undefined;
    /** 系统背景 */
    backgroundUrl: string | undefined;
    /** 租户身份 */
    classes: number | undefined;
    /** 联系电话 */
    contactNumber: string | undefined;
    /** 域名地址 */
    domain: string | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 联系人 */
    linkman: string | undefined;
    /** 租户编号 */
    tenantCode: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}